import { render, staticRenderFns } from "./SocialLearningNoData.vue?vue&type=template&id=7973c58a&scoped=true&"
import script from "./SocialLearningNoData.vue?vue&type=script&lang=js&"
export * from "./SocialLearningNoData.vue?vue&type=script&lang=js&"
import style0 from "./SocialLearningNoData.vue?vue&type=style&index=0&id=7973c58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973c58a",
  null
  
)

export default component.exports